/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessage2Down = createReactComponent("message-2-down", "IconMessage2Down", [
  ["path", { d: "M8 9h8", key: "svg-0" }],
  ["path", { d: "M8 13h6", key: "svg-1" }],
  [
    "path",
    {
      d: "M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5",
      key: "svg-2"
    }
  ],
  ["path", { d: "M19 16v6", key: "svg-3" }],
  ["path", { d: "M22 19l-3 3l-3 -3", key: "svg-4" }]
]);

export { IconMessage2Down as default };
//# sourceMappingURL=IconMessage2Down.js.map
